import axios from "./api";

export const subscribe = (tier) =>
  axios.post("/api/subscription/subscribe", null, { params: { tier } });

export const openPortalChange = () =>
  axios.get("/api/subscription/portal/upgrade-or-downgrade");

export const openPortalCancel = () =>
  axios.get("/api/subscription/portal/cancel");

export const billingPortal = () =>
  axios.get("/api/subscription/billing-portal");